var _path, _rect;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRefreshCcwRec(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "limegreen",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M7.262 6.93C8.25 6.084 9.794 5.25 12 5.25c3.75 0 6.75 3.024 6.75 6.75a.75.75 0 01-1.5 0A5.237 5.237 0 0012 6.75c-1.794 0-3 .667-3.762 1.32-.07.06-.137.12-.2.18H9a.75.75 0 010 1.5H6.5A.75.75 0 015.75 9V6.5a.75.75 0 011.5 0v.44l.012-.01zM6 11.25a.75.75 0 01.75.75c0 2.9 2.35 5.25 5.25 5.25 1.427 0 2.642-.647 3.531-1.341.068-.053.134-.106.197-.159H15a.75.75 0 010-1.5h2.5a.75.75 0 01.75.75v2.5a.75.75 0 01-1.5 0v-.65c-.094.08-.193.16-.296.241-1.033.806-2.567 1.659-4.454 1.659A6.75 6.75 0 015.25 12a.75.75 0 01.75-.75z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 20,
    height: 20,
    rx: 5,
    fill: "none",
    stroke: "limegreen",
    strokeWidth: 1.5,
    opacity: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefreshCcwRec);
export default __webpack_public_path__ + "static/media/refresh-ccw-rec.ffce5431.svg";
export { ForwardRef as ReactComponent };